import validate from "/root/gastos-gub-uy/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/root/gastos-gub-uy/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/root/gastos-gub-uy/app/middleware/auth.ts"),
  guest: () => import("/root/gastos-gub-uy/app/middleware/guest.ts")
}